<template lang="pug">
div(v-if="plantilla")
  ods-sub-header(
    :is-absolute='false'
    :stretch='false').actionsCupons
    div.actionsLeft
      router-link(:to="{ name: namePathPrev, query: { activeTab: 'cupones' } }")
        ods-button(type="text" icon="ods-icon-arrow-left")
      p.glue {{ $t('loyalty.CouponsAsing', { alaplantilla: appProgramDescr }) }}
    div.actionsRight
      router-link(:to="{ name: namePathPrev, query: { activeTab: 'cupones' } }")
        ods-button(type="secondary" size="small") {{ $t('loyalty.prev') }}
      ods-button(type="primary" size="small" :disabled="assignCouponDisabled" @click="asignar") {{ $t('loyalty.assignCoupon') }}
  div
    ods-module
      div(slot="header").actionsModuleTitle
        span(v-if="coupon && coupon.registros") {{ $t('loyalty.selectAccountsCoupon', { nombrecupon: coupon.registros.descripcion }) }}
        ods-button(type="text" size="medium" @click="couponPreview()" )
          div.actionsRight
            img(:src="require('@/assets/icons/ticket.svg')" alt="Ticket")
            span {{ $t('loyalty.viewSelectedCoupon') }}
          coupon-preview(v-if="showPreview" :data="coupon")
      div.text_item
        span(v-if="coupon && coupon.registros") {{ $t('loyalty.selectAccountsCouponDesc') }}
        span {{ acconutsSelected.length ? ` (${acconutsSelected.length}/20)` : '' }}
        div.actionsModuleTitle
          filter-table(layout="text" @inputSearchFilter="inputSearchFilter")
          div(v-if="appliedFiltersNumber && appliedFiltersNumber > 0")
            ods-badge.item(type="secondary" :value="appliedFiltersNumber")
            ods-button(
              @click="activarBuscador"
              type="text"
              size="medium"
              :loading="isloadingCLCAC"
              :icon="buscadorAvanzado ? 'ods-icon-chevron-up' : 'ods-icon-chevron-down'"
              ) {{ $t('loyalty.advancedSearch') }}
          div(v-else)
            ods-button(
              @click="activarBuscador"
              type="text"
              size="medium"
              :loading="isloadingCLCAC"
              :icon="buscadorAvanzado ? 'ods-icon-chevron-up' : 'ods-icon-chevron-down'"
              ) {{ $t('loyalty.advancedSearch') }}
        div(v-if="buscadorAvanzado")
          advanced-search-asign(v-if="!isloadingCLCAC"
            :parametros="{}"
            @apply-advanced-search="applyAdvancedSearch")
        div
          ods-progress(
            :percentage="percentage"
            :stroke-width="1"
            color="#2e6c99"
            :show-text="false")
          accounts-coupon-table(:filterText="filterText" :lessHeight="buscadorAvanzado" @rows="rows")
</template>

<script>
import FilterTable from '@/components/shared/FilterTable'
import CouponPreview from '@/components/loyalty/Coupons/CouponPreview'
import AdvancedSearchAsign from '@/components/loyalty/Coupons/AdvancedSearchAsign'
import AccountsCouponTable from '@/components/loyalty/Coupons/AccountsCouponTable'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CouponsAsingAccounts',
  components: {
    'accounts-coupon-table': AccountsCouponTable,
    'filter-table': FilterTable,
    'advanced-search-asign': AdvancedSearchAsign,
    'coupon-preview': CouponPreview
  },
  data () {
    return {
      namePathPrev: 'CouponsAsing',
      namePathStart: 'coupons',
      appProgramDescr: '',
      appliedFiltersNumber: 0,
      percentage: 0,
      appliedFilters: [],
      loadingTableAccounts: true,
      buscadorAvanzado: false,
      filterText: null,
      coupon: {},
      showPreview: false,
      assignCouponDisabled: true,
      acconutsSelected: [],
      plantilla: null
    }
  },
  async mounted () {
    this.plantilla = this.$route.query.row
    console.log('this.plantilla', this.plantilla)
    this.appProgramDescr = sessionStorage.getItem('appProgramDescr')
    await this.getCoupon()
    // console.log('this.coupon', this.coupon)
  },
  destroyed () {
    var dataModel = {
      loyaltyAccount: '',
      sexo: '',
      nombreid: '',
      apellid1: '',
      apellid2: '',
      idclient: '',
      tipidcli: ''
    }
    this.setAdvancedSearchFilters(dataModel)
  },
  computed: {
    ...mapGetters(['isloadingCLCAC', 'getAdvancedSearch'])
  },
  methods: {
    ...mapActions(['getTemplateDetails', 'assignCouponALACU', 'setReloadAccountsToAssign', 'setAdvancedSearchFilters']),
    couponPreview () {
      this.showPreview = false
      setTimeout(() => {
        this.showPreview = true
      }, 50)
    },
    rows (rows) {
      // console.log('listening rows selected: ', rows)
      if (rows && rows.length < 21) {
        this.percentage = parseFloat((rows.length / 20 * 100).toFixed(2))
        this.assignCouponDisabled = false
        this.acconutsSelected = rows
        this.$notify({
          title: `${rows.length} ${rows.length === 1 ? 'cuenta seleccionada' : 'cuentas seleccionadas'}`,
          type: 'success',
          offset: 150,
          duration: 3000
        })
      } else if (rows.length > 20) {
        this.$notify({
          title: '20 cuentas máximo',
          message: `Si quieres seleccionar esta cuenta hay que quitar ${rows.length - 20} cuenta(s)`,
          type: 'warning',
          offset: 150,
          duration: 3000
        })
        this.assignCouponDisabled = true
      } else {
        this.percentage = 0
        this.acconutsSelected = []
        this.assignCouponDisabled = true
      }
    },
    asignar () {
      let churro = ''
      this.acconutsSelected.forEach(element => {
        // console.log(element.codcuent)
        churro += element.codcuent
      })
      this.$notify.closeAll()
      this.assignCouponALACU({
        fechafin: this.plantilla.fechafin.valueDate,
        numcupact: this.plantilla.num_cup_act,
        nummaxcup: this.plantilla.num_max_cup,
        impminimo: this.plantilla.imp_minimo,
        cuentasalta: churro
      }).then(resData => {
        if (resData && resData.registros && resData.retorno === '000') {
          const ok = resData.registros.cuentasok.length ? resData.registros.cuentasok.length / 20 : 0
          const ko = resData.registros.cuentasko.length ? resData.registros.cuentasko.length / 20 : 0
          const msg = ok && !ko ? `${ok} cuenta(s) bien` : ko && !ok ? `${ko} cuenta(s) mal` : `${ok} cuenta(s) bien y ${ko} cuenta(s) mal`
          this.$notify({
            title: 'Cupón asignando',
            message: msg,
            type: ok && !ko ? 'success' : ko && !ok ? 'error' : 'warning',
            offset: 180,
            duration: 2000
          })
          this.$router.push({ name: this.namePathStart, query: { activeTab: 'cupones' } })
        } else {
          this.$notify({
            title: 'Algo raro ha pasado',
            type: 'warning',
            offset: 180,
            duration: 2000
          })
        }
      }).catch(err => {
        this.$notify({
          title: 'Algo no funciona bien',
          message: err,
          type: 'warning',
          offset: 180,
          duration: 10000
        })
      })
    },
    async getCoupon () {
      this.getTemplateDetails().then(response => {
        if (response && response.registros && response.retorno === '000') {
          this.coupon = response
          this.setReloadAccountsToAssign(true)
        } else {
          this.$notify({
            title: 'ERROR en datos',
            message: `No hay datos válidos para ${this.plantilla.descripcion}.`,
            type: 'error',
            offset: 50,
            duration: 9000
          })
          this.$router.push({ name: this.namePathPrev, query: { activeTab: 'cupones' } })
        }
      })
    },
    inputSearchFilter (text) {
      // console.log(text)
      this.filterText = text
    },
    activarBuscador () {
      this.buscadorAvanzado = !this.buscadorAvanzado
    },
    applyAdvancedSearch (params) {
      this.activarBuscador()
      this.appliedFiltersNumber = Object.values(params).filter(x => (x !== null && x !== '')).length
      this.setReloadAccountsToAssign(true)
    }
  }
}
</script>

<style lang="scss">
.actionsModuleTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
